module.exports = __webpack_public_path__ + "media/images/get-involved-teaser-b4cbbbf809ea59c5a3c0e28b922303c2.jpg";